import LocalStorageService from "../../localStorage-service";

class GraphFactoryService {
    initEditor(wrapper, gridStep) {
        wrapper.innerHTML = '';
        const container = document.createElement('div');
        container.id = 'graphContainer';
        wrapper.appendChild(container);
        let graph;
        if (!window.mxClient.isBrowserSupported()) {
            // Displays an error message if the browser is not supported.
            window.mxUtils.error('Browser is not supported!', 200, false);
        } else {
            graph = this.initGraph(container, gridStep);
            this.setDefaultStyles(graph);
            new window.mxRubberband(graph);
        }

        return graph;
    }

    initGraph = (container, gridStep) => {
        const graph = new window.mxGraph(container);
        graph.useCssTransforms = false;
        graph.transparentBackground = false;
        graph.graphHandler.scaleGrid = true;
        graph.enablePagePadding = true;
        graph.resetEdgesOnResize = false;
        graph.resetEdgesOnMove = false;
        graph.resetEdgesOnConnect = false;
        graph.setPanning(true);
        graph.setupListeners();
        graph.setGridSize(gridStep);
        graph.setSchematicTypeId(LocalStorageService.getSchematicTypeId());
        graph.setConnectable(true);
        graph.setConnectableEdges(true);
        graph.setDisconnectOnMove(false);
        graph.setEnabled(true);
        graph.validateViewBackground();
        graph.setTooltips(true);
        return graph;
    };

    setDefaultStyles = (graph) => {
        const {mxConstants} = window;
        let style = graph.getStylesheet().getDefaultVertexStyle();
        style[mxConstants.STYLE_STROKECOLOR] = '#000';
        let edgeStyle = graph.getStylesheet().getDefaultEdgeStyle();
        edgeStyle['edgeStyle'] = 'segmentEdgeStyle';
        edgeStyle[mxConstants.STYLE_ENDARROW] = 0;

        // Adds cells to the model in a single step
        graph.getModel().beginUpdate();
        try {
            //Define styles for each mxCell (vertext and edge) that make up the schematic
            let container_style = {};
            container_style[mxConstants.STYLE_ENDARROW] = '0';
            container_style[mxConstants.STYLE_EDITABLE] = '0';
            container_style[mxConstants.STYLE_MOVABLE] = 1;
            container_style[mxConstants.STYLE_FOLDABLE] = 0;
            container_style[mxConstants.STYLE_BENDABLE] = '0';
            container_style[mxConstants.STYLE_RESIZABLE] = '0';
            container_style[mxConstants.STYLE_ROTATABLE] = '0';
            container_style[mxConstants.STYLE_DELETABLE] = '0';
            container_style[mxConstants.STYLE_STROKECOLOR] = 'transparent';
            container_style[mxConstants.STYLE_FONTCOLOR] = '#000000';
            container_style[mxConstants.STYLE_FILLCOLOR] = 'transparent';
            container_style[mxConstants.STYLE_FONTSIZE] = 30;
            container_style[mxConstants.STYLE_ALIGN] = mxConstants.ALIGN_LEFT;
            container_style[mxConstants.STYLE_VERTICAL_ALIGN] = mxConstants.ALIGN_BOTTOM;
            graph.getStylesheet().putCellStyle('container_style', container_style);


            let PinNumber_style = {};
            PinNumber_style[mxConstants.STYLE_ENDARROW] = '0';
            PinNumber_style[mxConstants.STYLE_EDITABLE] = '1';
            PinNumber_style[mxConstants.STYLE_MOVABLE] = 1;
            PinNumber_style[mxConstants.STYLE_FOLDABLE] = 0;
            PinNumber_style[mxConstants.STYLE_BENDABLE] = '0';
            PinNumber_style[mxConstants.STYLE_RESIZABLE] = '0';
            PinNumber_style[mxConstants.STYLE_ROTATABLE] = '0';
            PinNumber_style[mxConstants.STYLE_DELETABLE] = '0';
            PinNumber_style[mxConstants.STYLE_STROKECOLOR] = 'transparent';
            PinNumber_style[mxConstants.STYLE_FONTCOLOR] = '#000000';
            PinNumber_style[mxConstants.STYLE_FILLCOLOR] = '#DDDDDD';
            PinNumber_style[mxConstants.STYLE_FONTSIZE] = 14;
            PinNumber_style[mxConstants.STYLE_ALIGN] = mxConstants.ALIGN_LEFT;
            PinNumber_style[mxConstants.STYLE_VERTICAL_ALIGN] = mxConstants.ALIGN_MIDDLE;
            graph.getStylesheet().putCellStyle('PinNumber_style', PinNumber_style);

            let boundary_style = {};
            boundary_style[mxConstants.STYLE_ENDARROW] = '0';
            boundary_style[mxConstants.STYLE_EDITABLE] = '0';
            boundary_style[mxConstants.STYLE_MOVABLE] = 0;
            boundary_style[mxConstants.STYLE_FOLDABLE] = 0;
            boundary_style[mxConstants.STYLE_BENDABLE] = '0';
            boundary_style[mxConstants.STYLE_RESIZABLE] = '0';
            boundary_style[mxConstants.STYLE_ROTATABLE] = '0';
            boundary_style[mxConstants.STYLE_DELETABLE] = '0';
            boundary_style[mxConstants.STYLE_STROKECOLOR] = '#000000';
            boundary_style[mxConstants.STYLE_FONTCOLOR] = '#000000';
            boundary_style[mxConstants.STYLE_FILLCOLOR] = 'transparent';
            graph.getStylesheet().putCellStyle('boundary_style', boundary_style);

            let style = {};
            style[mxConstants.STYLE_ENDARROW] = '0';
            style[mxConstants.STYLE_EDITABLE] = '0';
            style[mxConstants.STYLE_MOVABLE] = 0;
            style[mxConstants.STYLE_FOLDABLE] = 0;
            style[mxConstants.STYLE_BENDABLE] = '0';
            style[mxConstants.STYLE_RESIZABLE] = '0';
            style[mxConstants.STYLE_ROTATABLE] = '0';
            style[mxConstants.STYLE_DELETABLE] = '0';
            style[mxConstants.STYLE_STROKECOLOR] = '#000000';
            style[mxConstants.STYLE_FONTCOLOR] = '#000000';
            style[mxConstants.STYLE_FILLCOLOR] = 'transparent';
            style[mxConstants.STYLE_PORT_CONSTRAINT] = 0;
            graph.getStylesheet().putCellStyle('symbol_style', style);

            let Line_style = {};
            Line_style[mxConstants.STYLE_ENDARROW] = 'mxConstants.ARROW_OVAL';
            Line_style[mxConstants.STYLE_STARTARROW] = mxConstants.ARROW_OVAL;
            Line_style[mxConstants.STYLE_ENDSIZE] = 0.1;
            Line_style[mxConstants.STYLE_STARTSIZE] = 0.1;
            Line_style[mxConstants.STYLE_EDITABLE] = 0;
            Line_style[mxConstants.STYLE_MOVABLE] = 0;
            Line_style[mxConstants.STYLE_FOLDABLE] = 0;
            Line_style[mxConstants.STYLE_BENDABLE] = 0;
            Line_style[mxConstants.STYLE_RESIZABLE] = 0;
            Line_style[mxConstants.STYLE_ROTATABLE] = 0;
            Line_style[mxConstants.STYLE_DELETABLE] = 0;
            Line_style[mxConstants.STYLE_STROKECOLOR] = '#000000';
            graph.getStylesheet().putCellStyle('Line_Style', Line_style);

            let Pin_style = {};
            Pin_style[mxConstants.STYLE_ENDARROW] = mxConstants.ARROW_OVAL;
            Pin_style[mxConstants.STYLE_STARTARROW] = mxConstants.ARROW_OVAL;
            Pin_style[mxConstants.STYLE_ENDSIZE] = 0.1;
            Pin_style[mxConstants.STYLE_STARTSIZE] = 0.1;
            Pin_style[mxConstants.STYLE_EDITABLE] = 0;
            Pin_style[mxConstants.STYLE_MOVABLE] = 0;
            Pin_style[mxConstants.STYLE_FOLDABLE] = 0;
            Pin_style[mxConstants.STYLE_BENDABLE] = 0;
            Pin_style[mxConstants.STYLE_RESIZABLE] = 0;
            Pin_style[mxConstants.STYLE_ROTATABLE] = 0;
            Pin_style[mxConstants.STYLE_DELETABLE] = 0;
            Pin_style[mxConstants.STYLE_STROKECOLOR] = '#AA0000';
            graph.getStylesheet().putCellStyle('Pin_style', Pin_style);

            let Connection_Style = {};
            Connection_Style[mxConstants.STYLE_EDGE] = mxConstants.EDGESTYLE_SEGMENT;
            Connection_Style[mxConstants.STYLE_ENDARROW] = 0;
            Connection_Style[mxConstants.STYLE_DELETABLE] = 0;
            Connection_Style[mxConstants.STYLE_STROKECOLOR] = '#4444AA';
            graph.getStylesheet().putCellStyle('Connection_Style', Connection_Style);
            graph.foldingEnabled = false;
            graph.setCellsResizable(false);
        } finally {
            // Updates the display
            graph.getModel().endUpdate();
        }

        graph.centerZoom = true;
    };

    setupZoom(graph) {
        window.mxEvent.addMouseWheelListener(window.mxUtils.bind(this, function (evt, up, force) {
            if (force || graph.isZoomWheelEvent(evt)) {
                var source = window.mxEvent.getSource(evt);

                while (source != null) {
                    if (source === graph.container) {
                        graph.tooltipHandler.hideTooltip();
                        let cursorPosition = new window.mxPoint(window.mxEvent.getClientX(evt), window.mxEvent.getClientY(evt));
                        graph.lazyZoom(up, false, null, cursorPosition);
                        window.mxEvent.consume(evt);

                        return false;
                    }

                    source = source.parentNode;
                }
            }
        }), graph.container);

        graph.enableZoomOptimizations();
        graph.resetScrollbars();
    }


}

export default new GraphFactoryService();
